import { render, staticRenderFns } from "./ManufacturerUpdates.vue?vue&type=template&id=052551a9&scoped=true"
import script from "./ManufacturerUpdates.vue?vue&type=script&lang=js"
export * from "./ManufacturerUpdates.vue?vue&type=script&lang=js"
import style0 from "./ManufacturerUpdates.vue?vue&type=style&index=0&id=052551a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052551a9",
  null
  
)

export default component.exports